import { Grid, Typography, useTheme } from "@mui/material";
import { AssessmentMode, AssessmentQuestionDto } from "generated/CoreApi_v1";
import React from "react";
import { useTranslation } from "react-i18next";
import { useInstanceContext } from "views/assessment/player/AssPlayerBase";
import { AssPlayerAlternativeAnswers } from "views/assessment/player/Question/AssPlayerAlternativeAnswers";
import { AssPlayerAnswer } from "views/assessment/player/Question/AssPlayerAnswer";
import { AssPlayerConfidenceLevel } from "views/assessment/player/Question/AssPlayerConfidenceLevel";
import { AssPlayerFeedback } from "views/assessment/player/Question/AssPlayerFeedback";
import { AssPlayerLostConnection } from "views/assessment/player/common/AssPlayerLostConnection";

interface IProps {
    essayText?: string;
    rating: number;
    selectedItems: string[];
    deployId?: string;
    lostConnection: boolean;
    onChangeEssay: (essay: string) => void;
    onChangeQuestion: (question: AssessmentQuestionDto) => void;
    onChangeMultiChoice: (selectedItems: string[]) => void;
    onChangeStar: (rating: number) => void;
}

export const AssPlayerQuestion: React.FC<IProps> = (props) => {

    const { essayText, rating, selectedItems, lostConnection, deployId, onChangeEssay, onChangeQuestion, onChangeMultiChoice, onChangeStar } = props;

    const ctx = useInstanceContext();

    const viewData = ctx.viewData!;
    const question = ctx.question!;

    const { t } = useTranslation("assessment");
    const theme = useTheme();

    if (question == undefined || question == null)
        return <></>;

    return (
        <>
            {
                ctx.selectedAlternative
                    ?
                    <AssPlayerAlternativeAnswers
                        instance={viewData}
                        question={question}
                        deployId={deployId}
                    />
                    :
                    <>
                        <Grid container direction="column" alignItems="stretch">
                            <Grid overflow="hidden" width="100%">
                                <Grid container direction="column">
                                    <Grid>
                                        <Typography variant="h5">
                                            {question.questionText}
                                        </Typography>
                                    </Grid>
                                    {
                                        question.revision?.totalAnswersVersions != undefined && question.revision?.totalAnswersVersions > 1 &&
                                        <Typography variant="bodyNotice">
                                            {t("AssPlayer.Question.VersionText", { count: question.version })}
                                        </Typography>
                                    }
                                    {
                                        !!question.remarks && question.remarks.length > 0 &&
                                        <Grid sx={{ maxHeight: "110px", overflowY: "auto" }}>
                                            <Typography variant="caption">
                                                {question.remarks}
                                            </Typography>
                                        </Grid>
                                    }
                                    {
                                        question.points != null && question.points > 0 &&
                                        <Grid >
                                            <Typography variant="caption" color={theme.palette.success.main}>
                                                {t("AssPlayer.Question.PointsText", { count: question.points })}
                                            </Typography>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                            <Grid size="grow" width="100%">
                                {
                                    lostConnection
                                        ? <AssPlayerLostConnection />
                                        : <AssPlayerAnswer
                                            viewData={viewData}
                                            question={question}
                                            deployId={deployId}
                                            selectedItems={selectedItems}
                                            essayText={essayText}
                                            rating={rating}
                                            onChangeMultiChoice={onChangeMultiChoice}
                                            onChangeQuestion={onChangeQuestion}
                                            onChangeEssay={onChangeEssay}
                                            onChangeStar={onChangeStar}
                                        />
                                }
                            </Grid>
                        </Grid>
                        {
                            viewData.mode == AssessmentMode.Challenge && selectedItems.length > 0 && question.revision == null &&
                            <AssPlayerConfidenceLevel
                                onClick={(confidenLevel) => ctx.saveQuestion(confidenLevel)}
                            />
                        }
                        <AssPlayerFeedback
                            viewData={viewData}
                            question={question}
                        />
                    </>
            }
        </>
    );
};
